
//Definición de defaults

export const defaultTipoAsentamiento: TipoAsentamientoProps = {
    idTipoAsentamiento:       0,
    clave:                '',
    descripcion:          '',  
    activo:               false,
}

// Creación de interfaces

export interface TipoAsentamientoProps{
    idTipoAsentamiento:         number;
    clave:                      string;
    descripcion:                string;
    activo:                     boolean;
}